import { isEmpty } from 'lodash';
import React, { useMemo } from 'react';
import { MultiSelect } from 'react-multi-select-component';
import { useTranslation } from 'react-i18next';
import SearchBar from '../../../../Components/Utility/FilterAction/SearchBar';
import { mappedArray } from './Constant';
import Filter from './Filter';

function NavBar(props) {
  const { t } = useTranslation('common');

  const { searchText, totalCount, selectedColumn, setSelectedColumn, handleSearch, testingSelectedIds, subBrandAccess } = props;

  // Filter mappedArray based on subBrandAccess permission
  const filteredMappedArray = useMemo(() => {
    if (subBrandAccess) {
      return mappedArray;
    }
    // Filter out Sub Brand field when user doesn't have access
    return mappedArray.filter((item) => item.label !== 'Sub Brand');
  }, [subBrandAccess]);

  const handleSelectChange = (selected) => {
    localStorage.setItem('todo_test_selected_options', JSON.stringify([...selected]));
    setSelectedColumn([...selected]);
  };

  const renderSelection = () => {
    if (selectedColumn?.length === filteredMappedArray?.length) {
      return t('TAKING_DATES.ALL_SELECTED');
    }

    if (isEmpty(selectedColumn)) {
      return t('TAKING_DATES.SELECT_COLUMN');
    }

    return `${selectedColumn?.length} ${t('TAKING_DATES.COLUMN_SELECTED')}`;
  };

  return (
    <div className="page-title-filter sticky">
      <div className="title-container d-flex align-items-center">
        <h4 className="title">{t('REPORTS.TESTING_TO_DO')}</h4>
      </div>
      <div className="search-filter">
        {testingSelectedIds && testingSelectedIds?.length > 0 && (
          <span className="d-none d-md-inline-block txt-selected-cnt">
            {testingSelectedIds?.length} {t('COSTING_TO_DO_LIST.RECORD_SELECTED')}
          </span>
        )}
        {totalCount > 0 && (
          <span className="d-none d-md-inline-block txt-selected-cnt">
            {totalCount} {t('COSTING_TO_DO_LIST.TOTAL_RECORDS')}
          </span>
        )}
        <div className="mobile-multi-search">
          <div className="custom-multiselect ">
            <MultiSelect
              name="attributes"
              options={filteredMappedArray}
              className="custom-multiselect-PO"
              value={selectedColumn}
              valueRenderer={renderSelection}
              labelledBy={t('COSTING_TO_DO_LIST.SELECT_ATTRIBUTES')}
              onChange={handleSelectChange}
            />
          </div>
          <SearchBar placeholder={t('TAKING_DATES.SERCH')} onSearch={handleSearch} value={searchText} />
        </div>
        <div className="mobile-btns">
          <Filter />
        </div>
      </div>
    </div>
  );
}

export default NavBar;
